import type {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import axios from "axios";
import cookies from "js-cookie";
import qs from "qs";

import { statusError } from "api/services/errors";
import { AUTHORIZATION, ACCESS_TOKEN } from "constants/common";

export const serverUrl = process.env.REACT_APP_API_URL;

export const onFulfilled = (config: InternalAxiosRequestConfig) => {
  const token = cookies.get(ACCESS_TOKEN);

  if (!token) {
    return config;
  }

  const newConfig = {
    data: {},
    ...config,
  };

  newConfig.headers[AUTHORIZATION] = `Bearer ${token}`;

  return newConfig;
};

export const responseError = async (error?: AxiosError) => {
  statusError(error);

  throw error;
};

axios.interceptors.request.use(onFulfilled, (e) => Promise.reject(e));
axios.interceptors.response.use((r) => r, responseError);

axios.defaults.baseURL = `${serverUrl}`;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.paramsSerializer = (params) =>
  qs.stringify(params, { arrayFormat: "comma", encode: false });

export default (requestOptions: AxiosRequestConfig) => axios(requestOptions);
